import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

import { getProfile } from './profile';

declare global {
	// tslint:disable-next-line:variable-name
	let PopupJs : {
		init(system : string, lang : string, identifier : string) : void;
	} | undefined;
}

export default class SamAGB extends Module {
	private scriptSrc! : string;
	public on(callback : Hook) {
		this.scriptSrc = this.$ctx.data('scriptSrc');
		callback();
	}

	public async after() {
		if((window as any).suppressDatausageOverlay) {
			return;
		}
		const user = (await getProfile()).getUser();
		if(!user) {
			return;
		}
		$.ajax({
			cache: true,
			dataType: 'script',
			url: this.scriptSrc,
			success() {
				PopupJs!.init('PORTAL', document.documentElement.lang, 'POPUP_Portal');
			},
		});
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/personalization/Tc.Module.SamAGB.ts